﻿import * as Backbone from 'backbone';
import * as _ from 'underscore';

import config from '../../common/config';

export var Model = Backbone.Model.extend({
    initialize: function () {
        this.set('Information', '');
        this.set('Address', '');
    }
});





